import React from "react";
import { useDispatch } from "react-redux";
import { HeaderComp } from "../TambahDaftarAset/HeaderComp";
import {InputFieldResponsive} from "../../component/Utils";
import { Label, Form } from "reactstrap";
import { editDataAction } from "../../config/redux/action";
import {
  PG_NAMA_ASET,
  PG_ALAMAT_ASET,
  PG_LUAS_TANAH ,
  PG_LUAS_BANGUNAN,
  PG_STATUS_ASET,
  PG_KETERANGAN,
  PG_PERUSAHAAN_ID,
  PG_LONGITUDE,
  PG_LATITUDE,
  PG_CREATE_BY_ID,
  PG_APPROVED_BY_ID,
  PG_UPDATED_BY_ID,
  PG_REJECTED_BY_ID,
  PG_CREATE_AT,
  PG_APPROVED_AT,
  PG_UPDATED_AT,
  PG_REJECTED_AT,
  BASE_URL,
  PG_TANAH_BANGUNAN,
  PG_KOORDINAT,
} from "../../constants";
import { useParams } from "react-router-dom";
import { Loader,Button } from "semantic-ui-react";
import Axios from "axios";
import { axiosConfig } from "../../utils/helper";
import LoadingTop from "../../component/LoadingTop";


export default () => {
  const { idDaftarAset } = useParams();
  const dispatch = useDispatch();
  const [daftarAset, setDaftarAset] = React.useState();

  const init = () => {
    const urlDaftarAset = `${BASE_URL}/daftar-aset/${idDaftarAset}`;
    const config = axiosConfig();
    Axios.get(urlDaftarAset, config).then((response) => {
      const pg = { ...response.data };
      setDaftarAset({ ...pg });
    });
  };

  const tombolkembali = (e) => {
    e.preventDefault();
    window.history.back();
  };

  React.useEffect(() => {
    init();
  }, []);

  const handleChange = (event, type) => {
    const { name, value } = event.target;
    setDaftarAset({ ...daftarAset, [name]: value });
    // dispatch({ type, data });
  };

  // if (Object.keys(pegawai).length === 0 && pegawai.constructor === Object) {
  if (!daftarAset) {
    return (
      <div className="w-100 d-flex justify-content-center my-5">
        <Loader active>Loading</Loader>
      </div>
    );
  }
  return (
    <>
      <LoadingTop />
      <HeaderComp title="Detail Aset" />
      <Form>
        <div className="container mt-3">
          <div className="row">
            <div className="col-md-12">
              <div className="card container shadow-sm py-3 border-0">
                <hr />
                <div className="mb-3">
                    <InputFieldResponsive
                    label="Perusahaan"
                    inputType={{
                      value: daftarAset.perusahaan.nama,
                      disabled: true,
                      required: true,
                      name: "perusahaan",
                    }}
                    onChange={(e) => handleChange(e, PG_PERUSAHAAN_ID)}
                  />
                  <InputFieldResponsive
                    label="Nama Aset "
                    inputType={{
                      value: daftarAset.namaAset,
                      disabled: true,
                      required: true,
                      name: "namaAset",
                    }}
                    onChange={(e) => handleChange(e, PG_NAMA_ASET)}
                  />
                  <InputFieldResponsive
                    label="Alamat"
                    inputType={{
                      value: daftarAset.alamat,
                      disabled: true,
                      required: true,
                      name: "alamat",
                    }}
                    onChange={(e) => handleChange(e, PG_ALAMAT_ASET)}
                  />
                  <InputFieldResponsive
                    label="Koordinat"
                    inputType={{
                      value: daftarAset.koordinat,
                      disabled: true,
                      required: true,
                      name: "koordinat",
                    }}
                    onChange={(e) => handleChange(e, PG_KOORDINAT)}
                  />
                  {/* <InputFieldResponsive
                    label="Latitude"
                    inputType={{
                      value: daftarAset.latitude,
                      disabled: true,
                      required: true,
                      name: "latitude",
                    }}
                    onChange={(e) => handleChange(e, PG_LATITUDE)}
                  />
                  <InputFieldResponsive
                    label="Longitude"
                    inputType={{
                      value: daftarAset.longitude,
                      disabled: true,
                      required: true,
                      name: "longitude",
                    }}
                    onChange={(e) => handleChange(e, PG_LONGITUDE)}
                  /> */}
                  <InputFieldResponsive
                    label="Luas Tanah"
                    inputType={{
                      value: daftarAset.luasTanah,
                      disabled: true,
                      required: true,
                      name: "luasTanah",
                    }}
                    onChange={(e) => handleChange(e, PG_LUAS_TANAH)}
                  />
                  <InputFieldResponsive
                    label="Luas Bangunan"
                    inputType={{
                      value: daftarAset.luasBangunan,
                      disabled: true,
                      name: "luasBangunan",
                    }}
                    onChange={(e) => handleChange(e, PG_LUAS_BANGUNAN)}
                  />
                  <InputFieldResponsive
                    label="Tanah atau Bangunan"
                    inputType={{
                      value: daftarAset.tanahBangunan,
                      disabled: true,
                      name: "tanahBangunan",
                    }}
                    onChange={(e) => handleChange(e, PG_TANAH_BANGUNAN)}
                  />
                  <InputFieldResponsive
                    label="Status Aset"
                    inputType={{
                      value: daftarAset.statusAset,
                      disabled: true,
                      name: "statusAset",
                    }}
                    onChange={(e) => handleChange(e, PG_STATUS_ASET)}
                  />
                  <InputFieldResponsive
                    label="Keterangan"
                    inputType={{
                      value: daftarAset.keterangan,
                      disabled: true,
                      name: "keterangan",
                    }}
                    onChange={(e) => handleChange(e, PG_KETERANGAN)}
                  />
                    <div className="d-flex justify-content-end">
                        <Button type="button"  color="blue" className="mr-3" onClick={(e) => tombolkembali(e)}>Back</Button>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
};
